// Ricerca a più parole per le liste (usata da colataService e gruService).
//
// Il testo digitato si divide in termini (separati da spazi o da "%"); una riga compare se OGNI termine
// si trova in almeno una delle colonne di ricerca, in qualsiasi ordine e su qualsiasi colonna:
//   "traslazione cca"  trova  "RIDUTTORE TRASLAZIONE CARRO OSSITAGLIO CCA/CCB"
// Si traduce in un filtro .or() di PostgREST per ogni termine; più .or() consecutivi si combinano in AND.
// Tutto avviene sul server (con paginazione), non sulle righe già scaricate.

const MAX_TERMINI = 8;

/** Termini di ricerca da un testo. I caratteri che romperebbero il filtro PostgREST diventano separatori. */
export const terminiDaTesto = (testo) => String(testo ?? '')
  .replace(/[%,()*\\"]/g, ' ')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, MAX_TERMINI);

/** Applica a `query` (supabase-js) la ricerca di `termini` sulle `colonne`. */
export const applicaRicercaTermini = (query, termini, colonne) => {
  if (!termini.length || !colonne?.length) return query;
  return termini.reduce(
    (q, t) => q.or(colonne.map((col) => `${col}.ilike.%${t}%`).join(',')),
    query,
  );
};
